/**
 * 色ボタンの重複を削除する
 * @param {HTMLElement} card
 */
function removeDuplicateColorButtons (card) {
    // 色のボタン一覧を取得
    const $colorButtons = card.querySelectorAll("button.card-color__btn");

    // ボタン一覧からdata-availableがtrueのものを抽出する。data-srcが同じボタンが複数ある場合は1点のみ抽出。
    const uniqueButtons = [];
    const seenSrc = [];

    $colorButtons.forEach(function (button) {
        if (button.dataset.available === "true") {
            const src = button.dataset.src;
            if (!seenSrc.includes(src)) {
                seenSrc.push(src);
                uniqueButtons.push(button);
            }
        }
    });

    // data-availableがfalseでuniqueButtonsに未追加のボタンを抽出。data-srcが同じボタンが複数ある場合は1点のみ抽出。
    $colorButtons.forEach(function (button) {
        if (button.dataset.available === "false") {
            const src = button.dataset.src;
            if (!seenSrc.includes(src)) {
                seenSrc.push(src);
                uniqueButtons.push(button);
            }
        }
    });

    //重複を削除したボタンを再度設定
    const $colorContent = card.querySelector(".card-color__content");
    if($colorContent) {
        $colorContent.innerHTML = ""; // リセット

        uniqueButtons.forEach(function (button) {
            $colorContent.appendChild(button);
        });

        $colorContent.style.display = "flex";
    }
}

/**
 * 色ボタンのクリックイベントを設定する
 * @param {HTMLElement} card
 */
function initEventColorButtons(card) {
    // 新しいcolorボタンを取得
    const $colorButtons = card.querySelectorAll("button.card-color__btn");

    // 有効な全てのbuttonからactiveクラスを削除
    const clearActive = (function () {
        $colorButtons.forEach(function (button) {
            button.classList.remove("active");
        });
    });

    // 各colorボタンにクリックイベントを設定
    $colorButtons.forEach(function (button) {
        button.addEventListener("click", function (e) {
            e.preventDefault();

            const src = this.dataset.src;
            const srcset = this.dataset.srcset;

            if(src && srcset) {
                const img = card.querySelector(".media-img");

                if(img) { // 画像のsrcとsrcsetを更新
                    img.setAttribute("src", src);
                    img.setAttribute("srcset", srcset);
                }
            }

            clearActive();
            this.classList.add("active");
        });
    });
}

function initColorButtons() {
    // card--mediaクラスを持つ全ての要素を取得
    const $mediaCards = document.querySelectorAll(".card--media");
    $mediaCards.forEach(function (card) {
        removeDuplicateColorButtons(card);
        initEventColorButtons(card);
    });
}

function initSliders() {
    var navIcon = '<svg viewBox="0 0 16 16" aria-hidden="true" focusable="false"><path d="M10.5 3.5 6 8l4.5 4.5-1.1 1.1L3.8 8l5.6-5.6 1.1 1.1Z" fill="currentColor"/></svg>';

    function updateCarouselState(carousel) {
        var track = carousel.querySelector('.card-color__content');
        var prev = carousel.querySelector('[data-card-color-prev]');
        var next = carousel.querySelector('[data-card-color-next]');
        if (!track || !prev || !next) return;

        var hasOverflow = track.scrollWidth > track.clientWidth + 1;
        carousel.classList.toggle('is-overflowing', hasOverflow);

        if (!hasOverflow) {
            prev.disabled = true;
            next.disabled = true;
            return;
        }

        prev.disabled = track.scrollLeft <= 1;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    function scrollTrack(track, direction) {
        var firstButton = track.querySelector('.card-color__btn');
        var buttonWidth = firstButton ? firstButton.getBoundingClientRect().width : 35;
        var gap = parseFloat(window.getComputedStyle(track).columnGap || window.getComputedStyle(track).gap) || 6;
        var amount = Math.max(buttonWidth + gap, track.clientWidth - buttonWidth - gap);

        track.scrollBy({
            left: direction * amount,
            behavior: 'smooth'
        });
    }

    function initColorCarousel(track) {
        if (track.closest('.card-color__carousel')) return;

        var carousel = document.createElement('div');
        var prev = document.createElement('button');
        var next = document.createElement('button');

        carousel.className = 'card-color__carousel';
        prev.type = 'button';
        prev.className = 'card-color__nav card-color__nav--prev';
        prev.setAttribute('aria-label', '前のカラーを表示');
        prev.setAttribute('data-card-color-prev', '');
        prev.innerHTML = navIcon;

        next.type = 'button';
        next.className = 'card-color__nav card-color__nav--next';
        next.setAttribute('aria-label', '次のカラーを表示');
        next.setAttribute('data-card-color-next', '');
        next.innerHTML = navIcon;

        track.parentNode.insertBefore(carousel, track);
        carousel.appendChild(prev);
        carousel.appendChild(track);
        carousel.appendChild(next);

        prev.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            scrollTrack(track, -1);
        });

        next.addEventListener('click', function (event) {
            event.preventDefault();
            event.stopPropagation();
            scrollTrack(track, 1);
        });

        track.addEventListener('scroll', function () {
            window.requestAnimationFrame(function () {
                updateCarouselState(carousel);
            });
        }, { passive: true });

        updateCarouselState(carousel);
    }

    document.querySelectorAll('.card-color__content').forEach(initColorCarousel);

    window.addEventListener('resize', function () {
        document.querySelectorAll('.card-color__carousel').forEach(updateCarouselState);
    });
}

document.addEventListener("DOMContentLoaded", function () {
    initColorButtons();
    initSliders();
});